// extracted by mini-css-extract-plugin
module.exports = {"addressBox":"AddressBox_addressBox__2KJk1"};